// frontend/src/features/livestock/photoInboxFormat.ts
// Dates in the photo inbox (plan 4.3, 4.4), shown in the browser's time zone.

import dayjs from 'dayjs';
import type { TakenAtSource } from '@/types/timeline';
import { parseServerDate as parse } from './monthGroups';

/** "14 Sep 2025, 18:22" */
export function formatTakenAt(iso: string): string {
  return parse(iso).format('D MMM YYYY, HH:mm');
}

/** "14 Sep, 18:22", under a tile whose month heads the section. */
export function formatTileDate(iso: string): string {
  return parse(iso).format('D MMM, HH:mm');
}

/** "14 Sep 2025", naming a photo in a sentence. */
export function formatPhotoDay(iso: string): string {
  return parse(iso).format('D MMM YYYY');
}

/** "Sep 2025" */
export function formatMonth(iso: string): string {
  return parse(iso).format('MMM YYYY');
}

/** The local calendar day, YYYY-MM-DD (an acquisition date). */
export function localDay(iso: string): string {
  return parse(iso).format('YYYY-MM-DD');
}

/** A date from the file's or the upload's time rather than the photo itself: worth checking. */
export function isGuessedDate(source: TakenAtSource): boolean {
  return source === 'file_modified' || source === 'upload';
}

/** The DateTimePicker's value (local "YYYY-MM-DD HH:mm:ss") for a server datetime. */
export function toPickerValue(iso: string): string {
  return parse(iso).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * A DateTimePicker value (local time) for the API: ISO 8601 with the
 * browser's offset ("2025-09-20T10:00:00+01:00"), so the server keeps the
 * local time the user picked along with the instant.
 */
export function pickerValueToIso(value: string): string {
  return dayjs(value).format();
}
